export default "__VITE_ASSET__BGng4hbV__"